export const BREAKPOINTS = {
  mobile: 768,
  mobileBeforeTablet: 1024,
  tablet: 1280,
  lgBeforeXl: 1100,
  xl: 1200,
  xlToXxl: 1390,
};
